import React, { useState } from "react";
import { useTranslation, initReactI18next } from "react-i18next";
import Logo from "../images/LogoBig.png";
import logotxt from "../images/logotxt.png";
import ob1 from "../images/ob1.svg";
import ob2 from "../images/ob2.svg";
import ob3 from "../images/ob3.svg";
import ob4 from "../images/ob4.svg";
import ob5 from "../images/ob5.svg";
import TriLogo from "../images/TriLogo.png";
import TriJS from "../images/TriJS.png";
import Wave from "react-wavify";
import i18n from "i18next";

// Initialize i18next
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: require("../locales/en.json"),
    },
    hi: {
      translation: require("../locales/hi.json"),
    },
    gu: {
      translation: require("../locales/gu.json"),
    },
    mr: {
      translation: require("../locales/mr.json"),
    },
    te: {
      translation: require("../locales/te.json"),
    },
    pu: {
      translation: require("../locales/pu.json"),
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

const Modal = () => {
  const { t, i18n } = useTranslation();
  const [step, setStep] = useState(1);
  const [isOpen, setIsOpen] = useState(true);
  const [selectedVision, setSelectedVision] = useState("normal");
  const [vision, setVision] = useState("normal");

  const nextStep = () => {
    setStep((prevStep) => prevStep + 1);
  };

  const prevStep = () => {
    setStep((prevStep) => prevStep - 1);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const handleVisionChange = (selectedVision) => {
    setVision(selectedVision);
  };
  // className={`rounded-full ${
  //   isLiked ? "bg-gray-300" : "bg-transparent"
  // }`}

  return (
    <>
      {isOpen && (
        <div className="fixed z-[9999999] inset-0 flex items-center justify-between">
          <div className="bg-white w-full flex items-center justify-center h-screen text-center">
            <div className="absolute bottom-0 left-0 right-0">
              <Wave
                mask="url(#mask)"
                fill={vision === "normal" ? "#49B5F0" : "#37B9DB"}
                options={{
                  height: 10,
                  amplitude: 20,
                  speed: 0.3,
                  points: 3,
                }}
              >
                <defs>
                  <linearGradient id="gradient" gradientTransform="rotate(90)">
                    <stop offset="0" stopColor="white" />
                    <stop offset="0.5" stopColor="black" />
                  </linearGradient>
                  {/* <mask id="mask">
                    <rect
                      x="0"
                      y="0"
                      width="2000"
                      height="100"
                      fill="url(#gradient)"
                    />
                  </mask> */}
                </defs>
              </Wave>
            </div>
          

            <div className="p-6 z-[9999999]">
              <img
                className=" top-0 mb-2 mx-auto md:w-[15%] md:h-[15%] w-[30%] h-[30%]"
                src="https://upload.wikimedia.org/wikipedia/commons/b/b1/Ministry_of_Jal_Shakti.svg"
                alt=""
              />
              <div className="mb-4">
                <label htmlFor="languageSelect">Select Language:</label>
                <select
                  id="languageSelect"
                  onChange={(e) => changeLanguage(e.target.value)}
                >
                  <option value="en">English</option>
                  <option value="hi">हिन्दी</option>
                  <option value="gu">ગુજરાતી</option>
                  <option value="mr">मराठी</option>
                  <option value="te">తెలుగు</option>
                  <option value="pu">ਪੰਜਾਬੀ</option>
                </select> <br/>
                <label>Select Vision:</label>

                <select
        className="mt-2"
        onChange={(e) => handleVisionChange(e.target.value)}
      >
        <option value="normal">Normal Vision</option>
        <option value="tritanopia">Tritanopia Vision</option>
      </select>
              </div>
              {step === 1 && (
                <>
                  <img
                    src={vision === "normal" ? Logo : TriLogo}
                    alt=""
                    className="w-[50%] md:w-[25%] mx-auto my-auto"
                  />
                  <img
                    src={vision === "normal" ? logotxt : TriJS}
                    alt=""
                    className="w-[40%] md:w-[20%] mx-auto my-auto mt-2"
                  />
                  {/* <h2 className="text-3xl  font-bold my-4">{t("welcome")}</h2> */}
                  {/* <p>{t("getStarted")}</p> */}
                  <button
                    className="mt-5 p-3 rounded-full bg-[#3a70a2] text-white hover:bg-blue-700 shadow-none"
                    onClick={nextStep}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#e3e3e3"
                        d="m14.475 12l-7.35-7.35q-.375-.375-.363-.888t.388-.887q.375-.375.888-.375t.887.375l7.675 7.7q.3.3.45.675t.15.75q0 .375-.15.75t-.45.675l-7.7 7.7q-.375.375-.875.363T7.15 21.1q-.375-.375-.375-.888t.375-.887z"
                      />
                    </svg>
                  </button>
                </>
              )}
              {step === 2 && (
                <>
                  <h2 className="text-2xl font-bold mb-4">{t("h1")}</h2>
                  <img
                    src={ob1}
                    className="mx-auto w-[40%] md:w-[15%] my-5"
                    alt=""
                  />
                  <p>{t("d1")}</p>
                  <div className="flex justify-between mt-4">
                    <button
                      className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 shadow-none"
                      onClick={prevStep}
                    >
                      {t("previous")}
                    </button>
                    <button
                      className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700 shadow-none"
                      onClick={nextStep}
                    >
                      {t("next")}
                    </button>
                  </div>
                </>
              )}
              {step === 3 && (
                <>
                  <h2 className="text-2xl font-bold mb-4">{t("h2")}</h2>
                  <img
                    src={ob2}
                    className="mx-auto w-[40%] md:w-[15%] my-5"
                    alt=""
                  />
                  <p>{t("d2")}</p>
                  <div className="flex justify-between mt-4">
                    <button
                      className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 shadow-none"
                      onClick={prevStep}
                    >
                      {t("previous")}
                    </button>
                    <button
                      className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700 shadow-none"
                      onClick={nextStep}
                    >
                      {t("next")}
                    </button>
                  </div>
                </>
              )}
              {step === 4 && (
                <>
                  <h2 className="text-2xl font-bold mb-4">{t("h3")}</h2>\
                  <img
                    src={ob3}
                    className="mx-auto w-[40%] md:w-[15%] my-5"
                    alt=""
                  />
                  <p>{t("d3")}</p>
                  <div className="flex justify-between mt-4">
                    <button
                      className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 shadow-none"
                      onClick={prevStep}
                    >
                      {t("previous")}
                    </button>
                    <button
                      className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700 shadow-none"
                      onClick={nextStep}
                    >
                      {t("next")}
                    </button>
                  </div>
                </>
              )}
              {step === 5 && (
                <>
                  <h2 className="text-2xl font-bold mb-4">{t("h4")}</h2>
                  <img
                    src={ob4}
                    className="mx-auto w-[40%] md:w-[15%] my-5"
                    alt=""
                  />
                  <p>{t("d4")}</p>
                  {/* Add form elements for the final step */}
                  <div className="flex justify-between mt-4">
                    <button
                      className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 shadow-none"
                      onClick={prevStep}
                    >
                      {t("previous")}
                    </button>
                    <button
                      className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-700 shadow-none"
                      onClick={closeModal}
                    >
                      {t("complete")}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
